import { observable } from 'mobx';
import { IFeed } from '../../../interfaces/IFeed';

export class Store {
  @observable public highlightColor: string = "#fc8a00";

  // Public properties
  @observable public environment: "Development" | "Test" | "Production";
  @observable public tenant: string;
  @observable public token: string;
  @observable public component: "IntraActive-Messages" | "IntraActive-Events";

  @observable public currentFeed: IFeed

}
